import { useEffect, useState, useCallback } from 'react';
import { getAPI } from '../../services/api.service';

type Notification = any; // replace with your real type

export function useNotifications() {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchNotifications = useCallback(async () => {
    let mounted = true;
    setLoading(true);
    setError(null);

    try {
      let userId: string | undefined;
      if (typeof window !== 'undefined') {
        const user = localStorage.getItem('user');
        if (user) {
          const parsed = JSON.parse(user);
          userId = parsed?._id ?? parsed?.user?.id ?? parsed?.id;
        }
      }

      if (!userId) {
        if (!mounted) return;
        setError('User not found');
        setNotifications([]);
        return;
      }

      const res = await getAPI<{ data: Notification[] }>(`notifications?userId=${userId}`);
      if (!mounted) return;

      if (res?.status === 200) {
        setNotifications(res?.data?.data ?? []);
      } else {
        setError((res as any)?.error ?? 'Failed to fetch notifications');
      }
    } catch (err: any) {
      if (!mounted) return;
      console.error('Fetch notifications error:', err);
      setError('Failed to fetch notifications');
    } finally {
      if (!mounted) return;
      setLoading(false);
    }

    return () => { mounted = false; };
  }, []);

  // fetch on mount
  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  // optionally expose a refetch function
  const refetch = useCallback(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  return {
    notifications,
    loading,
    error,
    refetch,
  };
}
